export default "__VITE_ASSET__e5541d48__"